import * as Ariakit from '@ariakit/react'
import classNames from 'classnames'
import * as React from 'react'

interface ItemsGroupProps extends Omit<React.HTMLProps<HTMLDivElement>, 'ref' | 'label'> {
  /**
   * Group label
   */
  label?: string
}

export const ItemsGroup = React.forwardRef(function ItemsGroup(
  { label, children, ...props }: React.PropsWithChildren<ItemsGroupProps>,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  return (
    <Ariakit.SelectGroup
      {...props}
      ref={ref}
      className={classNames(
        props.className,
        'flex w-full flex-col border-t border-gray-100 first:border-t-0 dark:border-gray-600'
      )}
    >
      {label && <Ariakit.SelectGroupLabel className="px-2 text-2xs text-gray-500">{label}</Ariakit.SelectGroupLabel>}
      {children}
    </Ariakit.SelectGroup>
  )
})
